// Copyright © 2026 Neosocios - Seguimiento De Conversiones

document.addEventListener("DOMContentLoaded", function () {

  // ==========================================
  // UTILIDADES COMPARTIDAS
  // ==========================================

  function getURLParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name) || "";
  }

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)")
    );
    return match ? match[2] : "";
  }

  function getGclidFromCookie() {
    const gclAw = getCookie("_gcl_aw");
    if (gclAw) {
      const parts = gclAw.split(".");
      return parts[parts.length - 1] || "";
    }
    return "";
  }

  function getTrackingData() {
    return {
      source:   getURLParameter("utm_source"),
      medium:   getURLParameter("utm_medium"),
      campaign: getURLParameter("utm_campaign"),
      term:     getURLParameter("utm_term"),
      content:  getURLParameter("utm_content"),
      fbp:      getCookie("_fbp"),
      fbc:      getCookie("_fbc"),
      ttp:      getCookie("_ttp"),
      ttclid:   getCookie("ttclid"),
      gclid:    getGclidFromCookie(),
    };
  }

  // ==========================================
  // MÓDULO 1: CART ATTRIBUTES (CHECKOUT ESTÁNDAR)
  // ==========================================
  (function initCartAttributes() {
    "use strict";

    const trackingUpdated = sessionStorage.getItem("tracking_updated");
    if (trackingUpdated === "true") return;

    setTimeout(function () {
      try {
        const td = getTrackingData();
        const attributes = { Neosocios: "true" };

        if (td.source)   attributes.Source   = td.source;
        if (td.medium)   attributes.Medium   = td.medium;
        if (td.campaign) attributes.Campaign = td.campaign;
        if (td.term)     attributes.Term     = td.term;
        if (td.content)  attributes.Content  = td.content;
        if (td.fbp)      attributes.fbp      = td.fbp;
        if (td.fbc)      attributes.fbc      = td.fbc;
        if (td.ttp)      attributes.ttp      = td.ttp;
        if (td.ttclid)   attributes.ttclid   = td.ttclid;
        if (td.gclid)    attributes.gclid    = td.gclid;

        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes }),
        })
          .then((response) => {
            if (response.ok) {
              const updatedFields = Object.keys(attributes).filter(
                (key) => key !== "Neosocios"
              );
              console.log(
                `Neosocios: Cart attributes updated - ${updatedFields.length} fields: ${updatedFields.join(", ")}`
              );
              sessionStorage.setItem("tracking_updated", "true");
            }
            return response.json();
          })
          .catch((error) =>
            console.error("Neosocios: Error updating cart attributes:", error)
          );
      } catch (error) {
        console.error("Neosocios: Error in cart attributes module:", error);
      }
    }, 2000);
  })();

  // ==========================================
  // MÓDULO 2: EASYSELL FORM POPULATION
  // ==========================================
  (function initEasySellPopulation() {
    "use strict";

    let easySellPopulated = false;

    function populateEasySellFields() {
      if (easySellPopulated) return;

      try {
        const td = getTrackingData();
        const fieldsSet = [];

        // Campo Neosocios - SIEMPRE
        const neosociosTextarea = document.querySelector(
          'textarea[placeholder="Neosocios"]'
        );
        if (neosociosTextarea) {
          neosociosTextarea.value = "true";
          ["input", "change"].forEach((evt) =>
            neosociosTextarea.dispatchEvent(new Event(evt, { bubbles: true }))
          );
          fieldsSet.push("Neosocios: true");
        }

        // Resto de campos
        const fieldsToCheck = [
          { name: "Source",   value: td.source,   placeholder: "Source"   },
          { name: "Medium",   value: td.medium,   placeholder: "Medium"   },
          { name: "Campaign", value: td.campaign, placeholder: "Campaign" },
          { name: "Term",     value: td.term,     placeholder: "Term"     },
          { name: "Content",  value: td.content,  placeholder: "Content"  },
          { name: "fbp",      value: td.fbp,      placeholder: "fbp"      },
          { name: "fbc",      value: td.fbc,      placeholder: "fbc"      },
          { name: "ttp",      value: td.ttp,      placeholder: "ttp"      },
          { name: "ttclid",   value: td.ttclid,   placeholder: "ttclid"   },
          { name: "gclid",    value: td.gclid,    placeholder: "gclid"    },
        ];

        fieldsToCheck.forEach(({ name, value, placeholder }) => {
          if (value && value.trim()) {
            const textarea = document.querySelector(
              `textarea[placeholder="${placeholder}"]`
            );
            if (textarea) {
              textarea.value = value.trim();
              ["input", "change"].forEach((evt) =>
                textarea.dispatchEvent(new Event(evt, { bubbles: true }))
              );
              fieldsSet.push(`${name}: ${value}`);
            }
          }
        });

        easySellPopulated = true;

        if (fieldsSet.length > 0) {
          console.log(
            `Neosocios: EasySell populated - ${fieldsSet.length} fields: ${fieldsSet.join(", ")}`
          );
        }
      } catch (error) {
        console.error("Neosocios: Error populating EasySell fields:", error);
      }
    }

    function waitForEasySellForm() {
      if (document.querySelector(".es-group")) {
        setTimeout(populateEasySellFields, 3000);
        return;
      }

      let observerDisconnected = false;
      const observer = new MutationObserver((mutations) => {
        if (observerDisconnected) return;
        try {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                const found =
                  (node.querySelector && node.querySelector(".es-group")) ||
                  (node.matches && node.matches(".es-group"));
                if (found) {
                  setTimeout(populateEasySellFields, 3000);
                  observer.disconnect();
                  observerDisconnected = true;
                }
              }
            });
          });
        } catch (error) {
          console.error("Neosocios: Error in EasySell observer:", error);
          observer.disconnect();
          observerDisconnected = true;
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });

      setTimeout(() => {
        if (!observerDisconnected) {
          observer.disconnect();
          observerDisconnected = true;
        }
      }, 30000);
    }

    try {
      waitForEasySellForm();
    } catch (error) {
      console.error("Neosocios: Error initializing EasySell module:", error);
    }
  })();

  // ==========================================
  // MÓDULO 3: RELEASIT FORM POPULATION
  // ==========================================
  (function initReleasitPopulation() {
    "use strict";

    function populateReleasitFields() {
      const td = getTrackingData();

      const fieldMappings = {
        Neosocios: {
          selector: '._rsi-modal-fields-item:has(input[name="additionals_text_input_Neosocios"]) input',
          value: "true",
        },
        Source: {
          selector: '._rsi-modal-fields-item:has(input[name="additionals_text_input_Source"]) input',
          value: td.source,
        },
        Medium: {
          selector: '._rsi-modal-fields-item:has(input[name="additionals_text_input_Medium"]) input',
          value: td.medium,
        },
        Campaign: {
          selector: '._rsi-modal-fields-item:has(input[name="additionals_text_input_Campaign"]) input',
          value: td.campaign,
        },
        Term: {
          selector: '._rsi-modal-fields-item:has(input[name="additionals_text_input_Term"]) input',
          value: td.term,
        },
        Content: {
          selector: '._rsi-modal-fields-item:has(input[name="additionals_text_input_Content"]) input',
          value: td.content,
        },
        fbp: {
          selector: '._rsi-modal-fields-item:has(input[name="additionals_text_input_fbp"]) input',
          value: td.fbp,
        },
        fbc: {
          selector: '._rsi-modal-fields-item:has(input[name="additionals_text_input_fbc"]) input',
          value: td.fbc,
        },
        ttp: {
          selector: '._rsi-modal-fields-item:has(input[name="additionals_text_input_ttp"]) input',
          value: td.ttp,
        },
        ttclid: {
          selector: '._rsi-modal-fields-item:has(input[name="additionals_text_input_ttclid"]) input',
          value: td.ttclid,
        },
        gclid: {
          selector: '._rsi-modal-fields-item:has(input[name="additionals_text_input_gclid"]) input',
          value: td.gclid,
        },
      };

      setTimeout(() => {
        const fieldsSet = [];

        Object.entries(fieldMappings).forEach(([fieldName, config]) => {
          if (fieldName === "Neosocios" || config.value) {
            const input = document.querySelector(config.selector);
            if (input) {
              input.value = config.value;
              ["input", "change"].forEach((evt) =>
                input.dispatchEvent(new Event(evt, { bubbles: true }))
              );
              fieldsSet.push(`${fieldName}: ${config.value}`);
            }
          }
        });

        if (fieldsSet.length > 0) {
          console.log(
            `Neosocios: Releasit populated - ${fieldsSet.length} fields: ${fieldsSet.join(", ")}`
          );
        } else {
          console.log(
            "Neosocios: Releasit form detected but no fields could be populated"
          );
        }
      }, 3000);
    }

    function waitForReleasitForm() {
      if (document.querySelector("._rsi-modal-fields-item")) {
        console.log("Neosocios: Releasit form detected");
        populateReleasitFields();
        return;
      }

      let observerDisconnected = false;
      const observer = new MutationObserver((mutations) => {
        if (observerDisconnected) return;
        try {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                const found =
                  (node.querySelector && node.querySelector("._rsi-modal-fields-item")) ||
                  (node.matches && node.matches("._rsi-modal-fields-item"));
                if (found) {
                  console.log("Neosocios: Releasit form detected");
                  populateReleasitFields();
                  observer.disconnect();
                  observerDisconnected = true;
                }
              }
            });
          });
        } catch (error) {
          console.error("Neosocios: Error in Releasit observer:", error);
          observer.disconnect();
          observerDisconnected = true;
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });

      setTimeout(() => {
        if (!observerDisconnected) {
          observer.disconnect();
          observerDisconnected = true;
        }
      }, 30000);
    }

    try {
      waitForReleasitForm();
    } catch (error) {
      console.error("Neosocios: Error initializing Releasit module:", error);
    }
  })();

});